// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateResponsibleDealerCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_RESPONSIBLE_DEALER_CRITERIA,
    value
});

export const resetCriteria = dealers => ({
    dealers,
    type: actions.RESET_RESPONSIBLE_DEALER_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/action-creators/criteria.js